<script>
	import { Button, ButtonGroupV2, Text } from '@Shelly/shelly-design-system';
	import { postReq } from 'src/services/http';
	import { user_settings } from 'src/stores/account/user';
	import { format } from 'svelte-i18n';

	let activeButton = 1;

	if ($user_settings.units.date_format === 'eu') {
		activeButton = 1;
	} else {
		activeButton = 2;
	}

	const saveDateFormat = async (dateFormat, activeCode) => {
		activeButton = activeCode;

		const res = await postReq('/user/set_account_units', {
			set: 'date_format',
			val: dateFormat,
		});

		if (res.isok) {
			user_settings.set({
				...$user_settings,
				units: { ...$user_settings.units, date_format: dateFormat },
			});
		}
	};
</script>

<div class="d-flex gap-s justify-content-between align-items-center">
	<div>
		<Text styleType="body" class="mb-s"
			>{$format('label_date_format', { default: 'Date Format' })}</Text
		>
		<Text styleType="body-small" class="text-color-muted"
			>{$format('label_date_format_description', {
				default: 'Choose between US or EU format',
			})}</Text
		>
	</div>

	<ButtonGroupV2
		id="buttongroup-xder5xw"
		aria-label={$format('label_date_format', { default: 'Date Format' })}
		noWrap
		orientation="horizontal"
	>
		<Button class={activeButton === 1 && 'active'} size="m" on:click={() => saveDateFormat('eu', 1)}
			>EU</Button
		>
		<Button class={activeButton === 2 && 'active'} size="m" on:click={() => saveDateFormat('us', 2)}
			>US</Button
		>
	</ButtonGroupV2>
</div>
